import { Box, Paper, Typography } from '@mui/material';
import * as React from 'react';

export const HistoricoHeader: React.FC = () => {
  return (
    <Box
      sx={{
        px: { xs: 2, md: 3 },
        width: '100%',
        mb: 1,
        pr: '0px !important',
        pl: '15px !important',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          maxWidth: 900,
          width: '100%',
          mx: 'auto',
          p: 1,
          borderRadius: 2,
          backgroundColor: 'rgba(25, 118, 210, 0.08)',
          border: '1px solid',
          borderColor: '#e76f51',
          position: 'relative',
          overflow: 'hidden',
          paddingLeft: '20px !important',
          '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
            width: '4px',
            backgroundColor: '#e76f51',
          },
        }}
      >
        {/* Mensagem */}
        <Box>
          <Typography
            variant="body1"
            sx={{
              color: 'text.primary',
              fontSize: { xs: '0.9rem', md: '1rem' },
              lineHeight: 1.8,
              textAlign: 'justify',
              '& .destaque': {
                fontWeight: 500,
                color: 'primary.dark',
              },
            }}
          >
            <div
              style={{
                color: '#e76f51',
                fontSize: '10pt',
                textAlign: 'center',
              }}
            >
              *** No histórico de eventos, você pode visualizar seus eventos
              CONCLUÍDOS.
            </div>
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};
